import React, { useState } from 'react';
import axios from 'axios';
const apiBase = process.env.REACT_APP_API;

const DownloadExcelButton = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      alert('Please select both start and end dates.');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${apiBase}/analytics/dashboard/payments/download`, // Replace with your actual API endpoint
        { startDate, endDate },
        {
          responseType: 'blob', // important to handle file download
        }
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a temporary download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'purchased_courses.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      alert('Failed to download file');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className=" ">
      <div className="flex flex-col sm:flex-row gap-6 sm:gap-2 pt-8 sm:pt-6 items-start sm:items-center">
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="border rounded px-2 py-2"
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="border rounded px-2 py-2"
        />
        <button
          onClick={handleDownload}
          disabled={loading}
          className="bg-myBlue text-white px-4 py-2 rounded hover:bg-myPurple disabled:opacity-50"
        >
          {loading ? 'Downloading...' : 'Download Excel'}
        </button>
      </div>
    </div>
  );
};

export default DownloadExcelButton;
